import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './ContactInformation.module.scss'
import { emailAddressAction } from 'redux/actions'
import { useDispatch, useSelector } from 'react-redux'

const EmailAddress = ({ t, emailAddressValid, validateEmailAddress, emailAddressError, setIsError }) => {
  const dispatch = useDispatch()
  const [isFocussed, SetIsFocussed] = useState(false)

  const emailAddress = useSelector((state) => state.app.emailAddress)

  const handleEmail = (e) => {
    try {
      let email = e.currentTarget.value.replace(/\s/g, '')
      dispatch(emailAddressAction(email))
      // validateEmailAddress(email)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const handleOnBlur = () => {
    SetIsFocussed(false)
    validateEmailAddress(emailAddress)
  }

  return (
    <div className={styles['fields_margin']}>
      <div
        className={
          emailAddressValid === true
            ? emailAddress !== '' && 'form-group has-success'
            : emailAddressValid === false && 'form-group ns-form-group-message-error'
        }
      >
        <label className="control-label" htmlFor="EmailAddress">
          <b>{t('contact_info.email_address')}</b>
        </label>
        <div className="help-field">{t('contact_info.your_receipt_will_be')}</div>
        {emailAddressValid === false && (
          <div className="ns-form-error-container has-error error-msg-align">
            <i className={['fa fa-exclamation-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
            <div className={isFocussed ? 'help-block-focused' : 'help-block'}>{t(emailAddressError)}</div>
          </div>
        )}
        <input
          type="text"
          id="EmailAddress"
          className={'form-control ' + styles['field_width_25_em']}
          // onBlur={handleOnBlur}
          value={emailAddress}
          onChange={handleEmail}
          onFocus={() => SetIsFocussed(true)}
          autoComplete="off"
          maxLength="50"
        />
        {emailAddressValid === true && emailAddress !== '' && (
          <i className={['fa fa-check-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
        )}

        {/* <div className="help-field">{t('contact_info.your_receipt_will_be')}</div> */}
      </div>
    </div>
  )
}

export default withTranslation('common')(EmailAddress)
